<template>
  <div class="v-orders container">
    <!-- action-bar -->
    <action-bar class="head-bar action-bar">
      <div class="left" slot="left">
        <button @click.stop="$router.push('/home/hall')">{{'购彩大厅'}}</button>
      </div>

      <div class="title" slot="title">
        <span>{{'上周下注状况'}}</span>
      </div>
    </action-bar>

    <!-- main-table -->
    <div class="v-main">
        <v-table show-total :data="last_week" :columns="columns" @goto = "goto" >
          <span slot="count" slot-scope="{row}">{{row.count}}</span>

          <span slot="totaldate">上周合计</span>
          <span slot="totalcount" slot-scope="{total}">{{total}} 注</span>
        </v-table>


      <p>本周下注状况</p>
      <v-table class="f-s15" show-total :data="current_week" :columns="columns" @goto = "goto" >
        <span slot="count" slot-scope="{row}">{{row.count}}</span>

        <span slot="totaldate">本周合计</span>
        <span slot="totalcount" slot-scope="{total}">{{total}} 注</span>
      </v-table>


    </div>

  </div>
</template>

<script>
  import ActionBar from '@/components/action-bar';
  import VTable from '@/components/table';
  import {history} from '@/service/report';
  export default {
    name: "v-orders",
    components: {ActionBar, VTable},
    data () {
      return {
          current_week:[],
          last_week:[],
        data: [
          {type: '北京PK10',  date: '2019-09-02', count: 1, money: 0, commission:0, w_f: 0},
          {type: '北京PK10',  date: '2019-09-02', count: 2, money: 0, commission:0, w_f: 0},
          {type: '重庆时时彩',  date: '2019-09-02', count: 5, money: 0, commission:0, w_f: 0},
          {type: '重庆时时彩',  date: '2019-09-02', count: 0, money: 0, commission:0, w_f: 0},
          {type: '重庆时时彩',  date: '2019-09-02', count: 0, money: 0, commission:0, w_f: 0},
          {type: '广东快乐十分',  date: '2019-09-02', count: 0, money: 0, commission:0, w_f: 0},
          {type: '广东快乐十分',  date: '2019-09-02', count: 0, money: 0, commission:0, w_f: 0},
          {type: '广东快乐十分',  date: '2019-09-02', count: 0, money: 0, commission:0, w_f: 0},
          {type: '广东快乐十分',  date: '2019-09-02', count: 0, money: 0, commission:0, w_f: 0},
        ]
      }
    },
    created(){
        history().then(res=>{
            this.current_week = res.data.current_week.map(item=>{
                 item.mdate ='<span style="color:blue">'+ item.date +'<br/>'+ item.weekday+'</span>';
                item.results = item.result>= 0?'<span style="color:red" >'+item.result+'</span>' :'<span style="color:#0f0" >'+item.result+'</span>';
                return item;
            })

            this.last_week = res.data.last_week.map(item=>{
                item.mdate ='<span style="color:blue">'+ item.date +'<br/>'+ item.weekday+'</span>';
                item.results = item.result>= 0?'<span style="color:red" >'+item.result+'</span>' :'<span style="color:#0f0" >'+item.result+'</span>';
                return item;
            })
            this.last_week 
            console.log(current_week);
        })
    },
    methods:{
        goto(item){
            console.log(1111,item);
            this.$router.push({path:'/home/settled',query: item})
        }
    },

    computed: {
      columns () {
        return [
          {
            title: '日期',
            key: 'mdate',
            width: '30%',
            align: 'center'
          },
          {
            title: '注数',
            key: 'count',
            width: '10%',
            align: 'center'
          },
          {
            title: '下注金额',
            key: 'bet_money',
            width: '15%',
            align: 'center'
          },
          {
            title: '有效金额',
            key: 'bet_money_real',
            width: '15%',
            align: 'center'
          },
          {
            title: '佣金',
            key: 'commission',
            width: '15%',
            align: 'center',
          },
          {
            title: '盈亏',
            key: 'results',
            width: '15%',
            align: 'center',
            rkey:'result' 
          }
        ]
      }
    }
  }
</script>

<style scoped lang="less">
  .v-orders{
    .head-bar {
      z-index: 100;
      position: relative;

      .left {
        width: 140px;

        > button {
          height: 60px;
        }
      }

      .title {
        display: flex;
        text-align: center;
        align-items: center;
        font-weight: bold;
        justify-content: center;

        > button {
          width: 50px;
          height: 50px;
          border: 1px solid #b40f06;
          position: relative;
          margin-left: 10px;
          border-radius: 25px;

          &:after {
            top: 22px;
            left: 13px;
            display: block;
            content: "";
            position: absolute;
            border-top: 10px solid #fff;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-bottom: none;
            transition: transform 0.2s linear;
          }
        }
      }

      button {
        color: #fff;
        border: 1px solid #b70a00;
        padding: 0 16px;
        position: relative;
        font-size: 24px;
        background: #e8291d;
        background: -webkit-gradient(linear, 0 0, 0 70%, from(#f94539), to(#e8291d));
        box-shadow: 0 2px 2px #fc7f77 inset;
        border-radius: 10px;
      }
    }
    .v-main{
      position: relative;
      box-sizing: border-box;
      padding-bottom: 60px;
      background-color: #fff;
      >p{
        color: #fff;
        height: 70px;
        display: flex;
        font-size: 30px;
        margin-top: 20px;
        font-weight: bold;
        align-items: center;
        justify-content: center;
        background-color: #e72317;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/history/index.vue